import axios from "axios";


/**
 *
 * @status no delete
 * @class UserService
 */
class UserService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Leonel Contreras
   * @description Handle event to get the user information from auth0
   * @date 20-07-2020
   * @status no delete
   * @param {Object} auth0Id
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async getUser(auth0Id, token) {
    let mail = localStorage.getItem('token')
    mail = JSON.parse(mail)
    mail = mail.user?.internalData?.email
    let response = await axios.get(`${this.apiUrl}/user-auth-passthrough?auth0Id=${auth0Id}&email=${mail}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  }

  /**
  * @author Leonel Contreras
  * @description Handle event to get the user information from auth0
  * @date 20-07-2020
  * @status no delete
  * @param {Object} auth0Id
  * @param {String} token
  * @returns {Object}
  * @memberof UserService
  */
  async getUserEmailVerificationStatus(email) {
    let response = await axios.get(`${this.apiUrl}/user-email-verification-status-passthrough?email=${email}`);
    return response.data.data;
  }

  /**
   * @author Alan Aguilar
   * @description Handle event to update the user information in A3cloud and hibou.legal
   * @date 05-10-2020
   * @status no delete
   * @param {Object} user
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async updateUser(user, token) {
    let response = await axios.put(`${this.apiUrl}/user`, user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Get collaborators
   * @updatedDate 23-06-2022
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async getUsersCollaboratorAdmin(token) {
    let response = await axios.get(`${this.apiUrl}/users-collaborator-admin-passthrough`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data.data;
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Get roles signature profile for users
   * @updatedDate 8-7-2022
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */

  async getRolesAssignView(token) {
    let response = await axios.get(`${this.apiUrl}/roles-assign-view-passthrough`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data.data;
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Get roles for user by email
   * @updatedDate 11-7-2022
   * @status no delete
   * @param {String} token
   * @returns {Object}
   * @memberof UserService
   */
  async getRolesForUserByEmail(token, email) {
    email = email.toLowerCase();

    let response = await axios.get(
      `${this.apiUrl}/roles-user-by-email-passthrough?email=${email}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  /**
   * @author Juan Manuel Lamperti
   * @updatedBy Mario Carrizales 23-06-2023
   * @description Creates a new user collaborator
   * @updatedDate 14-7-2022
   * @status no delete
   * @param {String} token
   * @param {userData} body
   * @returns {Object}
   * @memberof UserService
   */
  async createNewUserCollaborator(token, email) {
    const userData = {
      email: email.toLowerCase()
    }

    let response = await axios.post(
      `${this.apiUrl}/create-new-user-invited-passthrough`,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Update user status
   * @updatedDate 14-7-2022
   * @status no delete
   * @param {String} token
   * @param {userProfileData} body
   * @returns {Object}
   * @memberof UserService
   */

  async updateUserStatus(token, userStatus) {
    let response = await axios.put(
      `${this.apiUrl}/update-user-status`,
      userStatus,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Junaid Khan
   * @description Update user email verification status
   * @updatedDate 22-04-2024
   * @status no delete
   * @param {userProfileData} body
   * @returns {Object}
   * @memberof UserService
   */

  async updateUserEmailVerificationStatus(email) {
    let response = await axios.put(
      `${this.apiUrl}/user-email-verification-status-passthrough`,
      {
        email
      },
    );
    return response.data;
  }

  /**
* @author Junaid Khan
* @description update the user profile picture 
* @date 25-04-2024
* @status no delete
* @param {String} token
* @param {Object} img
* @returns {Object}
* @memberof ClientService
*/
  async updateUserProfileImage(token, data) {
    let response = await axios.put(`${this.apiUrl}/user-profile-image-passthrough`, data, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }


  /**
  * @author Junaid Khan
  * @description traer imagen del cliente al back-end
  * @date 02-06-2021
  * @status no delete
  * @param {String} token
  * @param {Object} img
  * @returns {Object}
  * @memberof ClientService
  */
  async getUserProfileImage(token) {
    let response = await axios.get(`${this.apiUrl}/client-image-passthrough`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }


  /**
   * @author Juan Manuel Lamperti
   * @description Get current roles companies
   * @updatedDate 18-7-2022
   * @status no delete
   * @param {String} token
   * @param {userEmail} body
   * @returns {Object}
   * @memberof UserService
   */
  async getUserRolesCompany(token, userEmail, timezone) {
    userEmail = userEmail.toLowerCase();
    let response = await axios.get(
      `${this.apiUrl}/user-roles-company?email=${userEmail}&timezone=${timezone}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Juan Manuel Lamperti
   * @description Save roles for user company
   * @updatedDate 18-7-2022
   * @status no delete
   * @param {String} token
   * @param {userComapanies} body
   * @returns {Object}
   * @memberof UserService
   */

  async saveRolesForUserByCompany(token, userComapanies) {
    let response = await axios.post(
      `${this.apiUrl}/company-roles-for-user`,
      userComapanies,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
   * @author Adriana Fdz
   * @description update user roles
   * @param {*} token
   * @param {*} data
   * @return {*} 
   * @memberof UserService
   */
  async updateUserRoles(token, data) {
    let response = await axios.put(`${this.apiUrl}/user-role-passthrough`, data, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
   * @author Brayan Salas
   * @description Method to update phone number
   * @param {*} phoneNumber
   * @param {*} token
   * @return {*} 
   * @memberof UserService
   */
  async updatePhoneNumber(phoneNumber, token) {
    let response = await axios.put(`${this.apiUrl}/phone-number-passthrough`, { phoneNumber }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
   * @author Adriana Fernandez
   * @description Method to update language
   * @param {*} language
   * @param {*} token
   * @return {*} 
   * @memberof UserService
   */
  async updateLanguage(lng, token) {
    let response = await axios.put(`${this.apiUrl}/language`, { lng }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }
}

export { UserService as default };
